import request from '@/utils/request'
import { ReturnReceiptFilter, ReturnReceiptItemRes, ReturnReceiptSummaryRes } from './types'

/**
 * RGR09 센터도착 수령내역 조회 엔드포인트. (1.0 `/api/grid/search` 의 2.0 이관 — moms-be LOGISPRD-9576)
 *
 * | 동작        | 2.0 API                                | 1.0 MENU_CD        |
 * |-------------|----------------------------------------|--------------------|
 * | 머리표 조회 | `POST /api/v1/return/receipts/summary/search` | RGR09_HEAD         |
 * | 상세표 조회 | `POST /api/v1/return/receipts/search`         | RGR09_ITEM{탭번호} |
 *
 * 서버 페이징이 없다 — 조건에 걸린 전건이 한 번에 온다(BE 주석 "1.0 동등"). 0건은 200 + 빈 배열.
 */
export const RETURN_RECEIPT_SUMMARY_URL = '/api/v1/return/receipts/summary'
export const RETURN_RECEIPT_ITEMS_URL = '/api/v1/return/receipts'
/** 엑셀(암호 zip, POST) — BE 가 비밀번호·사유를 검증하고 감사로그를 남긴다(LOGISPRD-9577 요약 · LOGISPRD-14547 상세). */
export const RETURN_RECEIPT_SUMMARY_EXCEL_URL = `${RETURN_RECEIPT_SUMMARY_URL}/excel`
export const RETURN_RECEIPT_ITEMS_EXCEL_URL = `${RETURN_RECEIPT_ITEMS_URL}/excel`

/**
 * 조회는 본문(POST)으로 보낸다 — 반송번호 다건(최대 1,500건)을 GET 쿼리에 실으면 URL 이 약 2,100자를 넘어
 * 게이트웨이 앞단(awselb)에서 막힌다(LOGISPRD-14909). 빈 문자열은 GET 때처럼 싣지 않는다(BE 가 null 로 받던 값).
 */
const toBody = (filter: ReturnReceiptFilter) => ({
  clsDateFrom: filter.clsDateFrom || undefined,
  clsDateTo: filter.clsDateTo || undefined,
  rtnInvoiceNo: filter.rtnInvoiceNos,
  centerNm: filter.centerNm || undefined,
  assignDate: filter.assignDate || undefined,
})

/** 머리표 — 마감일자·입고센터·지정일자로 묶은 상태별 수량 집계. */
export const getReturnReceiptSummaries = (filter: ReturnReceiptFilter) =>
  request.post<ApiResponseV2<{ items: ReturnReceiptSummaryRes[] }>>(`${RETURN_RECEIPT_SUMMARY_URL}/search`, toBody(filter))

/**
 * 상세표 — `tabIdx` 미지정(=0, 전체)으로 전건을 받아 탭 전환은 클라이언트에서 거른다.
 * 탭마다 재조회해도 결과는 같지만(BE 가 같은 조건에 상태만 더한다) 전건을 이미 들고 있어 호출이 낭비다.
 */
export const getReturnReceiptItems = (filter: ReturnReceiptFilter) =>
  request.post<ApiResponseV2<{ items: ReturnReceiptItemRes[] }>>(`${RETURN_RECEIPT_ITEMS_URL}/search`, toBody(filter))
